<div class="not-found-container">
    <h1 class="not-found-heading">404 - Page Not Found</h1>
</div>